import { Box, Grid, Popup } from '@approvalmax/ui/src/components';
import range from 'lodash/range';
import { FC, memo } from 'react';
import Skeleton from 'react-loading-skeleton';

import { LoadingProps } from './Loading.types';

export const Loading: FC<LoadingProps> = memo((props) => {
    const { popupTitle } = props;

    return (
        <>
            <Popup.Header title={popupTitle} />

            <Popup.Body>
                <Box spacing='20 0'>
                    <Skeleton width={230} height={20} />
                </Box>

                <Grid gap={16}>
                    <Grid gap={8} width='50%'>
                        <Skeleton width={170} height={62} />
                    </Grid>

                    <Grid gridTemplateColumns='1fr 1fr' gap={16}>
                        {range(4).map((index) => (
                            <Skeleton key={index} height={56} />
                        ))}
                    </Grid>
                </Grid>

                <Box spacing='20 0'>
                    <Skeleton width={230} height={20} />
                </Box>

                <Grid gridTemplateColumns='1fr 1fr' gap={16}>
                    {range(4).map((index) => (
                        <Skeleton key={index} height={56} />
                    ))}
                </Grid>

                <Box spacing='20 0'>
                    <Skeleton width={230} height={20} />
                </Box>

                <Grid gridTemplateColumns='1fr 1fr' gap={16}>
                    {range(8).map((index) => (
                        <Skeleton key={index} height={56} />
                    ))}
                </Grid>

                <Box spacing='20 0'>
                    <Skeleton width={230} height={20} />
                </Box>

                <Grid gridTemplateColumns='1fr' gap={16}>
                    <Grid gridTemplateColumns='1fr 1fr' gap={16}>
                        <Skeleton height={56} />
                    </Grid>

                    <Skeleton height={126} />
                </Grid>

                <Box spacing='20 0'>
                    <Skeleton width={230} height={20} />
                </Box>

                <Grid gridTemplateColumns='1fr 1fr' gap={16}>
                    {range(2).map((index) => (
                        <Skeleton key={index} height={56} />
                    ))}
                </Grid>

                <Box spacing='20 0'>
                    <Skeleton width={230} height={20} />
                </Box>

                <Skeleton height={126} />
            </Popup.Body>
        </>
    );
});

Loading.displayName = 'Loading';
